import { FC, useEffect, useState } from "react";
import { MarketingEventsDistributorsDataProvider } from "../../../../Services/DataProviders/MarketingEventsDataProvider";
import { IMarketingEventsDistributorsViewDTO } from "../../../../libs/coreapi-dto/dirs/marketingEvents";
import { LoadingStatus, DocumentType } from "../../../../@types/enumsGlobal";
import { DefaultGrid } from "../../../../components/grids/default/defaultGrid";
import { PluginWrapper } from "../../../../components/plugins";
import useGridFilter, { CreateSelectorGridFilter } from "../../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import { usePluginContext } from "../../../../system/providers/plugin/PluginContextProvider";

export const MarketingEventsDistributorsGrid: FC<IGridProps> = (props) => {
    const appCtx = useAppContext();
    const pluginCtx = usePluginContext();

    const marketingEventsDistributorsDP = new MarketingEventsDistributorsDataProvider(appCtx.coreApiService);
    const [data, setData] = useState<IMarketingEventsDistributorsViewDTO[]>([]);
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>();
    const [totalCount, setTotalCount] = useState(0);
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.baseGridFilter ?? CreateSelectorGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>(props.data ?? []);

    const loadData = () => {
        if (!pluginCtx.masterGrid.selectedItem?.idGlobal) {
            return;
        }

        const hasMarketingEventFilter = gridFilter.columnFilters?.some(
            filter => filter.name === 'idMarketingEventGlobal'
        );

        if (!hasMarketingEventFilter) {
            return;
        }

        setLoadingStatus(LoadingStatus.InProcess);

        try {
            marketingEventsDistributorsDP.getView(gridFilter, (data, totalCount) => {
                setData(data);
                setTotalCount(totalCount);
                data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData);
            });
        } catch (error) {
            setLoadingStatus(LoadingStatus.Failed);
            console.error(error);
        }
    };
    
    useEffect(() => {
        if (!pluginCtx.masterGrid.selectedItem?.idGlobal && props.marketingFilters?.documentType === DocumentType.marketingEvents) {
            dispatchGridFilter({
                type: 'deleteColumnFilter',
                payload: "idMarketingEventGlobal"
            });
            return;
        }

        if(props.marketingFilters?.documentType === DocumentType.marketingEvents)
        dispatchGridFilter({
            type: 'addColumnFilter',
            payload: {
                name: "idMarketingEventGlobal",
                operator: "Eq",
                value: pluginCtx.masterGrid.selectedItem?.idGlobal
            }
        });
    }, [pluginCtx.masterGrid.selectedItem, props.marketingFilters?.documentType]);

    useEffect(() => {
        loadData();
    }, [gridFilter]);

    return (
        <PluginWrapper>
            <DefaultGrid
                showQuantity
                gridId={props.gridId}
                data={data}
                loadingStatus={loadingStatus}
                setLoadingStatus={setLoadingStatus}
                filter={gridFilter}
                getView={(gridFilter, callback) => {
                    marketingEventsDistributorsDP.getView(gridFilter, (data) => {
                        callback(data);
                    });
                }}
                totalCount={totalCount}
                dataProvider={marketingEventsDistributorsDP}
                selectedItem={selectedItem}
                selectedItems={selectedItems}
                onSelect={(row) => {
                    setSelectedItem(row)
                    props.onSelect?.(row)
                }}
                onMultipleSelect={(rows) => {
                    setSelectedItems(rows)
                    props?.onMultipleSelect?.(rows)
                }}
                multipleSelect={props.multipleSelect}
                plugin={props.plugin}
                onDoubleClick={(row) => props.onDoubleClick?.(row)}
                onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
            />
        </PluginWrapper>
    )
}